module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.9882/images/person-with-box/person-with-box@1x.svg"